import { render, staticRenderFns } from "./EventFormSectionWrapper.vue?vue&type=template&id=13f7b653&"
import script from "./EventFormSectionWrapper.vue?vue&type=script&lang=js&"
export * from "./EventFormSectionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EventFormSectionWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
